import * as React from 'react';

import 'bootstrap/dist/css/bootstrap-theme.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';

import Event from './Events';
import {Home} from './Home';

import {BrowserRouter as Router, Link, Redirect, Route} from 'react-router-dom';
import logo from './logo.svg';

import {PageHeader} from 'react-bootstrap';
import CustomNav from './CustomNav';
import EDDN from './EDDN';

import {Login} from './Login';

import {Register} from './Register';

const PrivateRoute = ({component: Component, loggedIn, ...rest}) => (
	<Route
		{...rest}
		render={props => (
			isAuthenticated.logged ? (
				<Component {...props} />
			) : (
				<Redirect to={{
					pathname: '/login',
					state: {from: props.location}
				}}
				/>
			)
		)}
	/>
);

export let isAuthenticated: any = {logged: false};

class App extends React.Component {
	public state: { loggedIn: boolean };

	constructor(props) {
		super(props);
		this.state = {loggedIn: false};
	}

	public render() {
		return (
			<Router>
				<div className={'container'}>
					<CustomNav loggedIn={isAuthenticated.logged}/>
					<PageHeader className={'container'}>
						<img className={'App-logo'} src={logo}/>
						Nova Force Data Network
					</PageHeader>

					<Route exact={true} path="/" component={Home}/>
					<Route exact={true} path="/register" component={Register}/>
					<Route exact={true} path="/login" component={Login}/>
					<PrivateRoute path="/events/:type?" component={Event} loggedIn={isAuthenticated.logged}/>
					<PrivateRoute path="/eddn" component={EDDN} loggedIn={isAuthenticated.logged}/>
				</div>
			</Router>
		)
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx